import { useAuth } from "@equidefi/portals/hooks/useAuth";
import { ApiInstance } from "../clients/api";
import { STOCK_TYPE_OPTIONS } from "../constants/offerings";

export const refreshToken = () => {
  // @TODO move referesh token functionality to useAuth hook
  const { setToken } = useAuth();

  return new Promise(function (resolve, reject) {
    ApiInstance.post("auth/refresh")
      .then((response) => {
        setToken(response.data.token);
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

export const getUser = () => {
  return new Promise(function (resolve, reject) {
    ApiInstance.get("me")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const updateUser = (request) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post("me", request)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const updatePassword = (id, password, token) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(
      `user/${id}/password`,
      {
        password: password,
      },
      { headers: { Authorization: `Bearer ${token}` } },
    )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
//#endregion

export const createOffering = (data) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post("/offering", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const updateOffering = (id, data) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(`/offering/${id}`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const getSettingsByOfferingId = (offeringId) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.get(`/offering/${offeringId}/setting`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const getSettingById = (settings, settingId) => {
  let setting = settings.filter((item) => item.id === settingId);
  let value = setting.length > 0 ? setting[0].value : "";
  return value;
};

export const updateSettingById = (offeringId, settingId, value) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(`/offering/${offeringId}/setting/${settingId}`, {
      value: value,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
//#endregion

//#region Investment

export const getInvestmentById = (id) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.get(`/investment/${id}`)
      .then((response) => {
        let investment = response.data;

        investment.amount = Number(investment.amount.replace(/[^0-9.-]+/g, ""));
        investment.approved_amount = investment.approved_amount
          ? Number(investment.approved_amount.replace(/[^0-9.-]+/g, ""))
          : 0;

        resolve(investment);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const getOfferingInvestments = async (offeringId) => {
  const response = await ApiInstance.get(`/offering/${offeringId}/investment`);
  return response.data;
};

export const createInvestment = (issuerId, offeringId, userId) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post("investment", {
      issuer_id: issuerId,
      offering_id: offeringId,
      investor_id: userId,
    })
      .then((response) => {
        ApiInstance.post(`investment/${response.data.id}/status/invite_sent`)
          .then((response) => resolve())
          .catch((error) => reject(error));
      })
      .catch((error) => reject(error));
  });
};

//#endregion

export const createOfferingDocument = (offeringId, document) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(`/v2/offerings/${offeringId}/documents`, document)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const deleteOfferingDocument = (offeringId, documentId) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.delete(`/v2/offerings/${offeringId}/documents/${documentId}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const createOfferingAgreement = (offeringId, agreement) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(`/offering/${offeringId}/agreement`, agreement)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const updateOfferingAgreement = (offeringId, agreementId, agreement) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.post(
      `/offering/${offeringId}/agreement/${agreementId}`,
      agreement,
    )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const deleteOfferingAgreement = (offeringId, agreementId) => {
  return new Promise(function (resolve, reject) {
    ApiInstance.delete(`/offering/${offeringId}/agreement/${agreementId}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const stockTypeName = (stockType) => {
  let value = "";
  let items = STOCK_TYPE_OPTIONS.filter((x) => x.value === stockType);
  if (items.length > 0) {
    value = items[0].label;
    return value;
  } else {
    return stockType;
  }
};

export const stockTypeOfferingPage = (stockType) => {
  let value = "";
  let items = STOCK_TYPE_OPTIONS.filter((x) => x.value === stockType);

  if (items.length > 0) {
    value = items[0].label;
    return value;
  } else {
    const common_stock = stockType?.split(" ").includes("common_stock");
    const common_stock2 = stockType?.split(" ").includes("Common");
    const preferred_stock = stockType?.split(" ").includes("preferred_stock");
    const preferred_stock2 = stockType?.split(" ").includes("Preferred");
    const safe = stockType?.split(" ").includes("Safe");
    const unit = stockType?.split(" ").includes("Unit");
    const in_lieu_of_cash = stockType?.split(" ")?.includes("lieu");

    if (safe) {
      return "SAFE";
    } else if (unit) {
      return "Unit";
    } else if (common_stock || common_stock2) {
      return "Common Stock";
    } else if (preferred_stock || preferred_stock2) {
      return "Preferred Stock";
    } else if (in_lieu_of_cash) {
      return "In Lieu of Cash";
    }
  }
};

export const isOfferingOwner = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "owner";
};

export const isIssuerOwner = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "owner";
};

export const isIssuerEditor = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "editor";
};

export const isIssuerViewer = (user, issuerId) => {
  return user?.roles?.issuer?.[issuerId] === "viewer";
};

export const hasIssuerRole = (user, issuerId) => {
  return Object.keys(user?.roles?.issuer ?? {}).includes(issuerId);
};

export const isAnyIssuerOwner = (user) => {
  const values = Object.values(user?.roles?.issuer ?? {});
  return values.includes("owner");
};

export const isAnyIssuerEditor = (user) => {
  const values = Object.values(user?.roles?.issuer ?? {});
  return values.includes("editor");
};

export const isOfferingEditor = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "editor";
};

export const isOfferingViewer = (user, offeringId) => {
  return user?.roles?.offering?.[offeringId] === "viewer";
};

export const hasOfferingRole = (user, offeringId) => {
  return Object.keys(user?.roles?.offering ?? {}).includes(offeringId);
};

export const isAdmin = (user) => {
  return user?.admin === true;
};
